// @flow

import type { Node } from 'react';

type TProps = {
  setPopupContent: (N: Node) => void
};

export const Header = 'Sizes Available';

export function Content({ setPopupContent }: TProps) {
  return (
    <div>
      <p>The range of finger sizes available for this band.</p>
    </div>
  );
}
